import { Component, OnInit , Inject, ViewChild,ElementRef} from '@angular/core';
import { FavoriteService } from 'src/app/services/favorite.service';
import { SettingsMainComponent } from 'src/app/components/settings/settings-main.component';
import {MessageService} from 'src/app/services/'

@Component({
  selector: 'bart-setting-favorite-parts',
  templateUrl: './setting-favorite-parts.component.html',
  styleUrls: ['./setting-favorite-parts.component.scss']
})
export class SettingFavoritePartsComponent implements OnInit {
  @ViewChild('txtList', {static: false}) searchElement: ElementRef;
  favoriteLists: any[];
  favoriteListParts: any[];
  edit:boolean= false;
  editFavListId : any= 0;
  favoriteListTypeId: number =1;
  norecord:boolean=true; 
  columnlist: any[]; 

  getFavListParam = {
    favoriteListTypeId : this.favoriteListTypeId,
    userId :   this.parent.userDetail.userId
    
  };

  constructor(private _FavoriteService:FavoriteService, private _messageService:MessageService, @Inject(SettingsMainComponent) private parent: SettingsMainComponent) {}

  ngOnInit() {
 
    this.getFavoriteParts(this.getFavListParam);

    this.columnlist = [
      { field: 'partNumber', header: 'Part Number',  display: 'table-cell' },
      { field: 'partDescription', header: 'Part Description',  display: 'table-cell' },
      { field: 'manufacturerName', header: 'Manufacturer', display: 'table-cell' }
    ];

  }

  public editFavList(favoriteListName:any, txtList:any, favListId:any) {
    
    this.searchElement.nativeElement.focus();
    this.edit = true;
    txtList.value=favoriteListName;
    this.editFavListId = favListId;
 
}
public selectedItemRow:number;
public highLightRow(itemId)
{
 this.selectedItemRow=itemId
}
public cancelFavList(txtList:any) {
 
      this.edit = false;
      txtList.value = "";
      this.editFavListId = 0;
}
  public removeFavList(favoriteListId:any)
   {     
     //if(confirm("You are about to delete an entire favorite list of parts, continue?"))
     this._messageService.confirmThis("You are about to delete an entire favorite list of parts, continue?",()=>
     {

      var DELETEFAVORITELISTPART = {
        favoriteListPartId : 0,
        favoriteListId: favoriteListId
      };

      var DELETEFAVORITELIST = {
        favoriteListId : favoriteListId 
      };
      this._FavoriteService.deleteFavoriteList(JSON.stringify({DELETEFAVORITELISTPART, DELETEFAVORITELIST}))
      .subscribe((listsResponse: any) => 
      {
        this.getFavoriteParts(this.getFavListParam);
        this.favoriteListParts = []; 
          }, (respose: Response) => {
            this.favoriteListParts = [];
            // handle error here
          }
        );

      });  
  }

public refreshFavParts(favoriteListPartId:any, favoriteListId: any, partexpired:any,iconconWithExp:any) 
{

  if(partexpired == "1")
  {
    //if(confirm("This part has been on your favorites list for 180 days. Do you wish to refresh it?"))
    this._messageService.confirmThis("This part has been on your favorites list for 180 days. Do you wish to refresh it?", ()=>  
    {
      
          var UPDATEFAVORITELISTPART = {
            favoriteListPartId:   favoriteListPartId
          };
          
          this._FavoriteService.updateFavoriteListPart(JSON.stringify({UPDATEFAVORITELISTPART}))
            .subscribe((listsResponse: any) => {              
                if(iconconWithExp==true && partexpired == "1")
                {
                      this.removeFavPart(favoriteListPartId, favoriteListId);
                }
              //this.getFavoriteParts(favoriteListId);
              this.getListParts(favoriteListId);

              }, (respose: Response) => {
                this.favoriteListParts = [];
                // handle error here
              }
            );
      },
      ()=> 
      {
        
        if(iconconWithExp==true && partexpired == "1")
          {
            this.removeFavPart(favoriteListPartId, favoriteListId);
          }


      })
      
      
    }
    else
    {
        this.removeFavPart(favoriteListPartId, favoriteListId);
    }

  }


public removeFavPart(favoriteListPartId:any, favoriteListId: any) {
  //if(confirm("Are you sure you want to delete this item, continue?"))
  this._messageService.confirmThis("Are you sure you want to delete this item, continue?", ()=>  
  {
    var DELETEFAVORITELISTPART = {
      favoriteListPartId : favoriteListPartId,
      favoriteListId: favoriteListId
    };


    this._FavoriteService.deleteFavoriteListPart(JSON.stringify({DELETEFAVORITELISTPART})   )
    .subscribe((listsResponse: any) => {

      this.getListParts(favoriteListId);
      // if(listsResponse.records.length> 0)
      // {
        
      // }
     
      }, (respose: Response) => {
        this.favoriteListParts = [];
        // handle error here
      }
    );

  })
}


  public async addFavList(txtBox:any) {
 
    var txtNewList = txtBox.value;

    if(txtNewList == "")
    {
      this._messageService.showAlertMessage("Please enter a name for the list");
      return;

    }

    var nameExists= await this.parent.checkFavoriteListName(txtNewList, this.favoriteListTypeId, "null");
 
    if(nameExists)
    {
      
      this._messageService.showAlertMessage("A list with that name already exists");
      return;
    }

    if (txtNewList != "")
    {
    var ADDFAVORITELIST = {
      favoriteListTypeId : this.favoriteListTypeId,
      userId :    this.parent.userDetail.userId,
      favoriteListName: txtNewList     
    };

    var GETFAVORITELIST = {
      favoriteListTypeId : this.favoriteListTypeId,
      userId :   this.parent.userDetail.userId,
      favoriteListName: txtNewList
    }; 

      this._FavoriteService.addFavoriteList( JSON.stringify({GETFAVORITELIST, ADDFAVORITELIST}) )
      .subscribe((listsResponse: any) => {
        
        txtBox.value = "";
        this.getFavoriteParts(this.getFavListParam);     
        
       
        }, (respose: Response) => {
          this.favoriteListParts = [];
          // handle error here
        }
      );
    
  }
  else
  { 
    this._messageService.showAlertMessage("Please enter a name for the list");
  }
  }
  
  
  public async updateFavList(txtBox:any) {    
   var txtNewList = txtBox.value;
   if (txtNewList != ""  && this.editFavListId != 0)
  {

   var nameExists= await this.parent.checkFavoriteListName(txtNewList, this.favoriteListTypeId, this.editFavListId);

    if(nameExists)
    {
      this._messageService.showAlertMessage("A list with that name already exists");
     
      return;
    }

    // if (txtNewList != null && this.editFavListId != 0)
    // {
    var UPDATEFAVORITELIST = {
      favoriteListTypeId : this.favoriteListTypeId,
      favoriteListId :   this.editFavListId,
      favoriteListName: txtNewList 
    };

    if (UPDATEFAVORITELIST != null) {
      
      this._FavoriteService.updateFavoriteList(JSON.stringify({UPDATEFAVORITELIST}))
      .subscribe((listsResponse: any) => {
        txtBox.value = "";
        txtNewList="";
        this.cancelFavList(txtBox);
        this.getFavoriteParts(this.getFavListParam);
        
       
        }, (respose: Response) => {
          this.favoriteListParts = [];
          // handle error here
        }
      );
    }
  }
  else
  { 
    this._messageService.showAlertMessage("Please enter a name for the list");
  }
  }


  public getListParts(favListId:any) {
    var GETFAVORITELISTPARTS = {
      favoriteListId : favListId        
    };
    
      this._FavoriteService.getFavoriteListParts(JSON.stringify({GETFAVORITELISTPARTS})  )
      .subscribe((listsResponse: any) => {
        if(listsResponse.records.length> 0)
        {
          this.favoriteListParts = [];
          this.favoriteListParts = listsResponse.records;
          this.norecord = true;
          this.getFavoriteParts(this.getFavListParam);
        }
        else
        {
          this.favoriteListParts = [];
          this.getFavoriteParts(this.getFavListParam);
          this.norecord = false;
        }
      
        }, (respose: Response) => {
          this.favoriteListParts = [];
          // handle error here
        }
      );
   
  }

  
  public getFavoriteParts(GETFAVORITELIST:any) {
    if (GETFAVORITELIST != null) {
     
      this._FavoriteService.getFavoriteList(JSON.stringify({GETFAVORITELIST}) )
      .subscribe((listsResponse: any) => {
        this.favoriteLists = [];///Added By Harikesh on 10-Oct-2020 for Defect#12240
        if(listsResponse.records.length> 0)
        {
          //this.favoriteLists = [];//Commented By Harikesh on 10-Oct-2020 for Defect#12240
          this.favoriteLists = listsResponse.records;
         
        } 
        }, (respose: Response) => {
          this.favoriteLists = [];
          // handle error here
        }
      );
    }
  }

}
